import ResizableScene from "../core/ResizableScene";
import BaseURL from "../utils/BaseURL";

export default class LoaderScene extends ResizableScene {
    

    preload(): void {
        this.load.on(Phaser.Loader.Events.FILE_COMPLETE, this.loadUpdate, this);
        this.load.setBaseURL(BaseURL.getBaseURL());
        this.events.on(Phaser.Scenes.Events.SHUTDOWN, this.shutdown, this);
    }

    create(): void {
        this.load.off(Phaser.Loader.Events.FILE_COMPLETE, this.loadUpdate, this);
    }
    
    protected loadUpdate(): void {
        console.log("override me");
    }
}
